import dayjs from 'dayjs';

export default function($apiInstance, $store) {
    return {
        // 보고서 계산 (재계산)
        calculateReport: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            try {
                const requestBody = {
                    eventId: params.eventId,
                    periodType: params.periodType || 'custom',
                    startDate: params.startDate,
                    endDate: params.endDate
                };

                const response = await $apiInstance.post('/events-v2/reports/calculate', requestBody);

                if (response.status === 200 || response.status === 201) {
                    if (success) success(response.data);
                }
            } catch (error) {
                console.error('Error calculating report:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 보고서 조회
        getReport: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            try {
                if (!params.eventId) {
                    throw new Error('eventId is required');
                }

                const queryParams = {
                    startDate: params.startDate || dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
                    endDate: params.endDate || dayjs().format('YYYY-MM-DD')
                };

                // periodType이 있으면 추가
                if (params.periodType) {
                    queryParams.periodType = params.periodType;
                }

                // eventId를 URL 파라미터로 전달
                const response = await $apiInstance.get(`/events-v2/reports/${params.eventId}`, {
                    params: queryParams
                });

                if (response.status === 200 || response.status === 201) {
                    if (success) success(response.data);
                }
            } catch (error) {
                console.error('Error fetching report:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 그룹별 상세 데이터 조회
        getGroupDetails: async (params, success, fail) => {
            $store.commit('setIsLoading', true);
            try {
                if (!params.reportId) {
                    throw new Error('reportId is required');
                }
                if (!params.group) {
                    throw new Error('group is required');
                }

                const queryParams = {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    sortBy: params.sortBy || 'surgeryDate',
                    sortOrder: params.sortOrder || 'desc'
                };

                const response = await $apiInstance.get(
                    `/events-v2/reports/${params.reportId}/groups/${params.group}/details`,
                    { params: queryParams }
                );

                if (response.status === 200 || response.status === 201) {
                    if (success) success(response.data);
                }
            } catch (error) {
                console.error('Error fetching group details:', error);
                if (fail) fail(error);
            } finally {
                $store.commit('setIsLoading', false);
            }
        },

        // 보정치 조회
        getAdjustments: async (params, success, fail) => {
            try {
                if (!params.reportId) {
                    throw new Error('reportId is required');
                }

                const response = await $apiInstance.get(
                    `/events-v2/reports/${params.reportId}/adjustments`
                );

                if (response.status === 200 || response.status === 201) {
                    if (success) success(response.data);
                }
            } catch (error) {
                console.error('Error fetching adjustments:', error);
                if (fail) fail(error);
            }
        },

        // HTML 리포트 목록 조회 (Promise 반환)
        fetchHtmlReportList: async () => {
            const response = await $apiInstance.get('/events-v2/reports/html');
            return response.data;
        },

        // HTML 리포트 콘텐츠 조회 (Promise 반환)
        fetchHtmlReportContent: async (filename) => {
            const response = await $apiInstance.get(`/events-v2/reports/html/${encodeURIComponent(filename)}`, {
                responseType: 'text',
            });
            return response.data;
        },
    };
}
